<template>
  <div>
    <h1>Contact Us</h1>
    <p>📍 Address: Niittysillankulma 2, Espoo, 02200, Finland</p>
    <p>📧 Email: info@primefusion.fi</p>
  </div>
</template>
